// Saga for paymentTerm

//import saga helpers
import { call, put, all, takeEvery } from "redux-saga/effects";

//import actionType
import {
  GET_PAYMENT_TERMS_LIST,
  GET_PAYMENT_TERMS_DATA,
  CREATE_PAYMENT_TERMS,
  UPDATE_PAYMENT_TERMS,
  DELETE_PAYMENT_TERMS,
} from "./actionType";

//import action
import {
  getPaymentTermsListSuccess,
  getPaymentTermsListFailure,
  getPaymentTermsDataSuccess,
  getPaymentTermsDataFailure,
  createPaymentTermsSuccess,
  createPaymentTermsFailure,
  updatePaymentTermsSuccess,
  updatePaymentTermsFailure,
  deletePaymentTermsSuccess,
  deletePaymentTermsFailure,
} from "./action";

//import api

import {
  getPaymentTermsListApi,
  getPaymentTermsDataApi,
  createPaymentTermsApi,
  updatePaymentTermsApi,
  deletePaymentTermsApi,
} from "../../helpers/fakebackend_helper";

// Gte Payment Terms List Saga
function* getPaymentTermsListSaga() {
  try {
    const response = yield call(getPaymentTermsListApi);
    yield put(getPaymentTermsListSuccess(response));
  } catch (error) {
    yield put(getPaymentTermsListFailure(error));
  }
}

// Watcher Saga
function* watcherGetPaymentTermsList() {
  yield all([takeEvery(GET_PAYMENT_TERMS_LIST, getPaymentTermsListSaga)]);
}

// Get Payment Terms Data Saga
function* getPaymentTermsDataSaga({ payload }) {
  try {
    const response = yield call(getPaymentTermsDataApi, payload);
    yield put(getPaymentTermsDataSuccess(response));
  } catch (error) {
    yield put(getPaymentTermsDataFailure(error));
  }
}

// Watcher Saga
function* watcherGetPaymentTermsData() {
  yield all([takeEvery(GET_PAYMENT_TERMS_DATA, getPaymentTermsDataSaga)]);
}

// Create Payment Terms Saga
function* createPaymentTermsSaga({ payload }) {
  try {
    const response = yield call(createPaymentTermsApi, payload);
    yield put(createPaymentTermsSuccess(response));
  } catch (error) {
    yield put(createPaymentTermsFailure(error));
  }
}

// Watcher Saga
function* watcherCreatePaymentTerms() {
  yield all([takeEvery(CREATE_PAYMENT_TERMS, createPaymentTermsSaga)]);
}

// Update Payment Terms Saga
function* updatePaymentTermsSaga({ payload }) {
  try {
    const response = yield call(updatePaymentTermsApi, payload);
    yield put(updatePaymentTermsSuccess(response));
  } catch (error) {
    yield put(updatePaymentTermsFailure(error));
  }
}

// Watcher Saga
function* watcherUpdatePaymentTerms() {
  yield all([takeEvery(UPDATE_PAYMENT_TERMS, updatePaymentTermsSaga)]);
}

// Delete Payment Terms Saga
function* deletePaymentTermsSaga({ payload }) {
  try {
    const response = yield call(deletePaymentTermsApi, payload);
    yield put(deletePaymentTermsSuccess(response));
  } catch (error) {
    yield put(deletePaymentTermsFailure(error));
  }
}

// Watcher Saga
function* watcherDeletePaymentTerms() {
  yield all([takeEvery(DELETE_PAYMENT_TERMS, deletePaymentTermsSaga)]);
}
// Saga Main function

export default function* PaymentTerm() {
  yield all([
    watcherGetPaymentTermsList(),
    watcherGetPaymentTermsData(),
    watcherCreatePaymentTerms(),
    watcherUpdatePaymentTerms(),
    watcherDeletePaymentTerms(),
  ]);
}
